<template>
  <v-card>
    <s-crud
      :config="config"
      title="Equipos TI"
      :filter="filter"
      search-input
      add
      edit
      remove
      excel
      @save="save($event)"
      @addEvent="onAddEvent"
      ref="scrudEquipment"
      nameScrud="scrudEquipment"
      height="480px"
      sortable
      @dblClick="onEditEvent($event)"
    >
      <template v-slot:options>
        <v-tooltip bottom="">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text black @click="openMassRegistrations()" small>
              <v-icon>mdi-plus-circle-multiple-outline</v-icon>
            </v-btn>
          </template>
          <span>Registro Masivo</span>
        </v-tooltip>
        <v-tooltip bottom="">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text black @click="sendReturnEmailWarehouse()" small :loading="sendingEmail">
              <v-icon>mdi-email-arrow-right</v-icon>
            </v-btn>
          </template>
          <span>Notificar Devoluciones a Almacén</span>
        </v-tooltip>
      </template>

      <template v-slot:filter>
        <v-container class="pa-2">
          <v-row dense>
            <v-col cols="12" sm="6" md="3" lg="2">
              <s-select-definition
                :def="1531"
                label="Tipo Asignación"
                v-model="filter.CgeTypeAssigns"
                clearable
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <s-select-definition
                :def="1583"
                label="Tipo Tenencia"
                v-model="filter.CgeTypeTenure"
                clearable
                hide-details
              />
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="3"
              v-if="filter.CgeTypeAssigns == 1 || filter.CgeTypeAssigns == 2"
            >
              <s-select-area label="Area" v-model="filter.AreID" hide-details />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="3"
              v-if="filter.CgeTypeAssigns == 3"
            >
              <s-select-definition
                :def="1534"
                label="Zona"
                v-model="filter.EanZone"
                :add="$fun.isAdmin()"
                hide-details
              />
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="2">
              <s-date
                v-model="filter.CgeDateFrom"
                label="Fecha desde"
                clearable
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <s-date
                v-model="filter.CgeDateUntil"
                label="Fecha hasta"
                clearable
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <s-select-definition
                :def="1541"
                label="Estado"
                v-model="filter.CgeStatus"
                clearable
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <s-select-definition
                :def="1530"
                label="Tipo Equipo"
                v-model="filter.CgeTypeEquipment"
                clearable
                hide-details
              />
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:AsgCharacteristicsOrAccessory="{ row }">
        <div style="display: flex; gap: 8px; padding: 6px">
          <v-tooltip bottom="">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                x-small
                color="dark"
                @click="AsgHistoryAssignaments(row)"
              >
                <v-icon :color="row.AssignmentCount > 0 ? 'success' : 'dark'"
                  >mdi-history</v-icon
                >
              </v-btn>
            </template>
            <span>Historial</span>
          </v-tooltip>

          <v-tooltip bottom="">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                x-small
                color="primary"
                @click="AsgCharacteristics(row)"
              >
                <v-icon>mdi-format-list-bulleted-type</v-icon>
              </v-btn>
            </template>
            <span>Características</span>
          </v-tooltip>

          <v-tooltip bottom="">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                x-small
                color="success"
                @click="AsgAccessory(row)"
              >
                <v-icon>mdi-playlist-plus</v-icon>
              </v-btn>
            </template>
            <span>Accesorios</span>
          </v-tooltip>
          <v-tooltip bottom="">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" x-small color="warning" @click="AsgLicense(row)">
                <v-icon>mdi-license</v-icon>
              </v-btn>
            </template>
            <span>Licencias</span>
          </v-tooltip>

          <v-tooltip bottom="" v-if="row.CgeTypeTenure == 2">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                x-small
                color="deep-orange"
                @click="openReturnSupplier(row)"
              >
                <v-icon color="white">mdi-truck-delivery</v-icon>
              </v-btn>
            </template>
            <span>Devolver Proveedor</span>
          </v-tooltip>

          <v-tooltip bottom="" v-if="row.IncidentCount > 0">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                x-small
                color="blue-grey"
                @click="openIncidences(row)"
              >
                <v-icon color="white">mdi-clipboard-text-clock-outline</v-icon>
              </v-btn>
            </template>
            <span>Incidencias</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:AsgCgeAssigns="{ row }">
        <v-chip
          small
          :color="row.StatusAssignment == 'Asignado' ? 'primary' : 'success'"
          class="pl-2 pr-2"
        >
          {{ row.StatusAssignment }}
        </v-chip>
      </template>

      <template v-slot:AsgStatusName="{ row }">
        <v-tooltip
          top=""
          v-if="
            row.CgeStatus == 2 &&
            (row.NtpFullName || row.AreName || row.EanZoneName)
          "
        >
          <template v-slot:activator="{ on }">
            <v-chip
              small
              v-on="on"
              :color="
                row.CgeStatus === 1
                  ? 'success'
                  : row.CgeStatus === 2
                  ? 'yellow'
                  : row.CgeStatus === 3
                  ? 'error'
                  : 'white'
              "
              class="pl-2 pr-2"
            >
              {{ row.CgeStatusName }}
              <v-icon>mdi-information-outline</v-icon>
            </v-chip>
          </template>
          <span
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            "
          >
            {{
              row.NtpFullName
                ? row.NtpFullName
                : row.AreName
                ? row.AreName
                : row.EanZoneName
            }}
            <br />
            <span style="font-size: 10px">
              {{ row.NtpFullName ? row.AreName : "" }}</span
            >
          </span>
        </v-tooltip>
        <v-chip
          v-else
          class="pl-2 pr-2"
          small
          :color="
            row.CgeStatus === 1
              ? 'success'
              : row.CgeStatus == 2
              ? 'yellow'
              : [3, 4].includes(row.CgeStatus)
              ? 'error'
              : 'warning'
          "
        >
          {{ row.CgeStatusName }}
        </v-chip>
      </template>

      <template v-slot:AsgCgeIDAnt="{ row }">
        <v-tooltip top="" v-if="row.CgeIDAnt">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <span
            style="
              font-size: 12px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            "
          >
            <span style="font-size: 12px">ID : {{ row.CgeIDAnt }}</span>
            <span style="font-size: 14px">
              {{ row.CgeTypeEquipmentNameAnt }}</span
            >
            <span style="font-size: 12px"
              >Serie : {{ row.CgeSerieNameAnt }}</span
            >
          </span>
        </v-tooltip>
      </template>

      <template v-slot:AsgEmailReturnSupplier="{ row }">
        <v-tooltip bottom="">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              v-if="row.CgeStatus == 4"
              x-small
              :color="row.EmailSentWarehouse ? 'grey' : 'blue'"
              :disabled="row.EmailSentWarehouse"
              @click="sendSingleReturnEmailWarehouse(row)"
            >
              <v-icon>mdi-email-arrow-right</v-icon>
            </v-btn>
          </template>
          <span>Notificar a Almacén</span>
        </v-tooltip>
      </template>

      <template v-slot="props">
        <v-container fluid>
          <v-row>
            <v-col cols="12" class="s-col-form" md="3">
              <s-select-definition
                :def="1530"
                label="Equipo"
                v-model="props.item.CgeTypeEquipment"
                searchable
                :add="$fun.isAdmin()"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3">
              <s-select-definition
                :def="1531"
                label="Tipo Asignación"
                v-model="props.item.CgeTypeAssigns"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3">
              <s-select-definition
                :def="1533"
                label="Marca"
                v-model="props.item.CgeBrand"
                searchable
                :add="$fun.isAdmin()"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3">
              <v-row dense no-gutters align="center">
                <v-col v-if="showAddModelInput" cols="12">
                  <v-text-field
                    v-model="newModelName"
                    label="Nuevo Modelo"
                    dense
                    hide-details
                    autofocus
                    @keyup.enter="saveNewModel('equipment')"
                    @keyup.esc="showAddModelInput = false; newModelName = ''"
                  >
                    <template v-slot:append>
                      <v-btn icon x-small color="success" @click="saveNewModel('equipment')">
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                      <v-btn icon x-small color="error" @click="showAddModelInput = false; newModelName = ''">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col v-else>
                  <v-autocomplete
                    :items="equipmentModels"
                    item-text="EmdName"
                    item-value="EmdID"
                    label="Modelo"
                    v-model="props.item.CgeModel"
                    clearable
                    hide-details
                  />
                </v-col>
                <v-col v-if="!showAddModelInput" cols="auto" class="pl-1">
                  <v-btn icon x-small color="primary" @click="showAddModelInput = true; newModelName = ''">
                    <v-icon>mdi-plus-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="s-col-form" md="3">
              <s-text
                :disabled="props.item.CgeID ? true : false"
                label="Serie"
                v-model="props.item.CgeSerie"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3">
              <s-date v-model="props.item.CgeDate" label="Fecha Adquisición" />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3">
              <s-select-definition
                :def="1583"
                label="Tipo Tenencia"
                v-model="props.item.CgeTypeTenure"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3">
              <s-text :label="props.item.CgeTypeEquipment == CELLPHONE_TYPE_ID ? 'IMEI' : 'Hostname'" v-model="props.item.CgeHostname" />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3" v-if="props.item.CgeTypeEquipment != CELLPHONE_TYPE_ID">
              <s-text
                label="AnyDesk"
                v-model="props.item.CgeAnydesk"
                ref="CgeAnydesk"
                type="text"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3">
              <s-select-definition
                :def="1541"
                label="Estado"
                v-model="props.item.CgeStatus"
                clearable
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="2">
              <v-switch
                label="Asignable"
                v-model="CgeAssigns"
                dense
                hide-details
              />
            </v-col>
          </v-row>
          <v-row v-if="props.item.CgeTypeTenure == 2">
            <v-col cols="12" class="s-col-form" md="6">
              <s-supplier
                label="Proveedor"
                v-model="props.item.SupplierObj"
                @input="onMainSupplierSelected(props.item, $event)"
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
    </s-crud>

    <v-dialog persistent v-model="openMass" v-if="openMass" max-width="900px">
      <v-card>
        <v-container>
          <v-row>
            <v-col>
              <s-toolbar
                no-border
                dark
                label="Carga Masiva"
                color="#8e8f91"
                :clear="!loading"
                @clear="clear()"
                :close="!loading"
                @close="openMass = false"
              >
              </s-toolbar>

              <v-card :loading="loading">
                <v-col>
                  <v-row>
                    <v-col>
                      <s-import-excel
                        v-if="dialogExcel"
                        :headers="headers"
                        @loaded="saveMassive($event)"
                      ></s-import-excel>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialogCharacteristics"
      v-if="dialogCharacteristics"
      max-width="500px"
    >
      <v-card>
        <v-container>
          <s-crud
            :config="configCharacteristics"
            title="Características"
            :filter="filterCharacteristicsOrAccessory"
            close
            add
            edit
            remove
            searchInput
            @save="saveCharacteristics($event)"
            @clearForm="clearCharacteristicForm"
            @close="dialogCharacteristics = false"
            @dblClick="onCharacteristicEdit($event)"
            @EditEvent="onCharacteristicEditFormOpen"
            ref="scrudCharacteristics"
          >
            <template v-slot="props">
              <v-container :key="props.item.EctID || 0">
                <v-row>
                  <v-col cols="12" class="s-col-form" md="6">
                    <s-select-definition
                      :def="1532"
                      :dgr="CgeIDGroup"
                      label="Nombre"
                      v-model="props.item.EctCharacteristics"
                      @change="onCharacteristicChange"
                      :add="$fun.isAdmin()"
                    />
                  </v-col>
                  <v-col cols="12" class="s-col-form" md="6">
                    <s-text
                      :disabled="hasDynamicFields(props.item.EctCharacteristics)"
                      :label="hasDynamicFields(props.item.EctCharacteristics) ? 'Valor (auto-calculado)' : 'Valor'"
                      v-model="props.item.EctValueCharacteristics"
                    />
                  </v-col>

                  <template v-if="characteristicTemplateMap[props.item.EctCharacteristics]">
                    <v-col
                      v-for="field in characteristicTemplateMap[props.item.EctCharacteristics]"
                      :key="field.key"
                      cols="12"
                      class="s-col-form"
                      md="6"
                    >
                      <s-text
                        :label="field.label"
                        v-model="dynamicDetails[field.key]"
                      />
                    </v-col>
                  </template>

                  <v-col cols="12" class="s-col-form" md="12">
                    <s-date
                      v-model="props.item.EctDate"
                      label="Fecha Adquisición"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </s-crud>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialogAccessory"
      v-if="dialogAccessory"
      max-width="800px"
    >
      <v-card class="rounded-xl">
        <div class="modern-header">
          <div class="header-content">
            <div class="header-left">
              <v-icon class="header-icon" size="28" color="white"
                >mdi-television</v-icon
              >
              <h2 class="header-title" style="font-size: 1.2rem">
                ACCESORIOS VINCULADOS
              </h2>
            </div>
            <div class="header-actions">
              <v-btn
                color="primary"
                v-if="![3, 4].includes(formEquipment.CgeStatus)"
                fab
                small
                @click="(showAddAccessory = true), (EayID = null)"
              >
                <v-icon color="white">mdi-plus</v-icon>
              </v-btn>
              <v-btn
                icon
                large
                class="close-btn ml-4"
                @click="dialogAccessory = false"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <v-col cols="12" md="8" v-if="showAddAccessory">
          <div class="d-flex align-end justify-end">
            <div class="flex-grow-1 mr-2">
              <s-select
                :clearable="true"
                :autocomplete="true"
                label="Accesorios disponibles"
                :items="itemsAccesoryAvailables"
                item-text="EayAccessoryFullName"
                item-value="EayID"
                placeholder="Seleccionar Accesorio"
                :slotTmp="true"
                v-model="EayID"
                id="EayID"
                ref="EayID"
              >
                <template #item="{ item }">
                  <div
                    style="display: flex; flex-direction: column; width: 100%"
                  >
                    <div class="font-weight-medium text-uppercase text-body-2">
                      {{ item.EayAccessoryFullName }}
                    </div>
                  </div>
                </template>
              </s-select>
            </div>
            <div class="header-actions">
              <v-btn
                class=""
                fab
                color="primary"
                x-small
                dark
                elevation="2"
                @click="saveAsignacionAccesory"
              >
                <v-icon color="white">mdi-content-save</v-icon>
              </v-btn>
              <v-btn
                class=""
                fab
                color="error"
                x-small
                dark
                elevation="2"
                @click="showAddAccessory = false"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>

        <v-card class="pb-4 col-12" flat>
          <v-data-table
            :headers="headersAccesoryHistory"
            :items="itemsAccesoryHistory"
            dense
            class="custom-table"
            item-key="EayID"
          >
            <template v-slot:item.EayAccessoryName="{ item }">
              {{ item.EayAccessoryName }}
              <template v-if="item.EayObservation">
                <h5 class="text-caption">{{ item.EayObservation }}</h5>
              </template>
              <v-chip x-small color="primary" v-if="item.EayPhoneNumber" class="mt-1">Tel: {{ item.EayPhoneNumber }}</v-chip>
            </template>

            <template v-slot:item.EayState="{ item }">
              <v-chip
                x-small
                outlined
                :color="[1, 2].includes(item.EayState) ? 'success' : 'error'"
                class="pa-2 rounded-xl pl-2 pr-2"
              >
                {{ item.EayStateName }}
              </v-chip>
            </template>

            <template v-slot:item.EayOptions="{ item }">
              <v-tooltip v-if="item.EayStatus == null" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="error"
                    fab
                    x-small
                    dark
                    elevation="2"
                    @click="removeAsignacionAccesory(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-attachment-remove</v-icon>
                  </v-btn>
                </template>
                <span>Liberar</span>
              </v-tooltip>

              <v-chip
                v-else
                x-small
                outlined
                :color="[1, 2].includes(item.EayStatus) ? 'success' : 'error'"
                class="pa-2 rounded-xl pl-2 pr-2"
              >
                {{ item.EayStatusDevolutionName }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card>

        <!-- <v-col>
                    <s-crud :config="configAccessory" title=" " :filter="filterCharacteristicsOrAccessory" noSearch
                        noToolbar @save="saveAccessory($event)" @close="dialogAccessory = false" ref="scrudAccessory">
                        <template v-slot="props">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" class="s-col-form" md="3">
                                        <s-select-definition :def="1543" label="Accesorio"
                                            v-model="props.item.EayAccessory" searchable :add="$fun.isAdmin()" />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="3" v-if="!props.item.EayObservation">
                                        <s-select-definition :def="1533" label="Marca" v-model="props.item.EayBrand"
                                            searchable :add="$fun.isAdmin()" clearable />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="3" v-if="!props.item.EayObservation">
                                        <v-autocomplete
                                            :items="equipmentModels"
                                            item-text="EmdName"
                                            item-value="EmdID"
                                            label="Modelo"
                                            v-model="props.item.EayModel"
                                            clearable
                                            hide-details
                                        />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="3" v-if="!props.item.EayObservation">
                                        <s-text :disabled="props.item.EayID ? true : false" label="Serie"
                                            v-model="props.item.EaySerie" />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="9" v-if="validatedItems(props.item)">
                                        <s-text label="Descripción" v-model="props.item.EayObservation" />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="3">
                                        <s-select-definition :def="1593" :add="$fun.isAdmin()" label="Estado"
                                            v-model="props.item.EayState" clearable />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="3">
                                        <s-date v-model="props.item.EayDate" label="Fecha Adquisición" />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>

                        <template v-slot:item.EayAccessoryName="{ item }">
                            {{ item.EayAccessoryName }}
                            <template v-if="item.EayObservation">
                                <h5 class="text-caption">{{ item.EayObservation }}</h5>
                            </template>
                        </template>

                        <template v-slot:item.EayState="{ item }">
                            <v-chip x-small outlined :color="[1, 2].includes(item.EayState) ? 'success' : 'error'"
                                class="pa-2 rounded-xl pl-2 pr-2">
                                {{ item.EayStateName }}
                            </v-chip>
                        </template>
                    </s-crud>
                </v-col> -->
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialogLicense"
      v-if="dialogLicense"
      max-width="900px"
    >
      <v-card class="rounded-xl">
        <div class="modern-header">
          <div class="header-content">
            <div class="header-left">
              <v-icon class="header-icon" size="28" color="white"
                >mdi-license</v-icon
              >
              <h2
                class="header-title"
                style="text-transform: uppercase; font-size: 1.2rem"
              >
                Licencias vinculadas
              </h2>
            </div>
            <div class="header-actions">
              <v-btn
                v-if="![3, 4].includes(formHistory.CgeStatus)"
                color="primary"
                fab
                small
                class=""
                @click="(showAddLicense = true), (TelID = null)"
              >
                <v-icon color="white">mdi-plus</v-icon>
              </v-btn>
              <v-btn
                icon
                large
                class="close-btn ml-4"
                @click="dialogLicense = false"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <v-col
          cols="12"
          md="8"
          v-if="showAddLicense && ![3, 4].includes(formHistory.CgeStatus)"
        >
          <div class="d-flex align-end justify-end">
            <div class="flex-grow-1 mr-2">
              <s-select
                :clearable="true"
                :autocomplete="true"
                label="Licencias disponibles"
                :items="itemsLicenseAvailables"
                item-text="TelLicenceName"
                item-value="TelID"
                placeholder="Seleccionar licencia"
                :slotTmp="true"
                v-model="TelID"
                id="TelID"
                ref="TelID"
              >
                <template #item="{ item }">
                  <div
                    style="display: flex; flex-direction: column; width: 100%"
                  >
                    <div class="font-weight-bold text-uppercase text-caption">
                      {{ item.TelLicenceName }}
                    </div>
                    <p
                      class="text--secondary text-caption ma-0 text-uppercase block"
                      style=""
                    >
                      {{
                        [item.TelEditionName, item.TelEmail, item.TelSerial]
                          .filter((v) => v)
                          .join(" |")
                      }}
                    </p>
                  </div>
                </template>
              </s-select>
            </div>
            <div class="header-actions">
              <v-btn
                class=""
                fab
                color="primary"
                x-small
                dark
                elevation="2"
                @click="saveAsignacionLicence"
              >
                <v-icon color="white">mdi-content-save</v-icon>
              </v-btn>
              <v-btn
                class=""
                fab
                color="error"
                x-small
                dark
                elevation="2"
                @click="showAddLicense = false"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>

        <v-card class="pb-4 col-12" flat>
          <v-data-table
            :headers="headersLicenceHistory"
            :items="itemsLicenceHistory"
            dense
            class="custom-table"
            item-key="TlhID"
          >
            <template v-slot:item.SecCreate="{ item }">
              {{ $fun.formatDateView(item.SecCreate) }}
            </template>
            <template v-slot:item.TelExpirationDate="{ item }">
              {{ $fun.formatDateView(item.TelExpirationDate) }}
            </template>
            <template v-slot:item.Status="{ item }">
              <v-chip
                class="px-2 white--text font-weight-semibold"
                x-small
                dark
                outlined
                :color="item.Status == 1 ? 'success' : 'red'"
              >
                {{
                  item.Status == 1
                    ? "ACTIVO"
                    : `Removido el ${$fun.formatDateView(item.EndDate)}`
                }}
              </v-chip>
            </template>
            <template v-slot:item.TelOptions="{ item }">
              <v-tooltip v-if="item.Status == 1" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="error"
                    fab
                    x-small
                    dark
                    elevation="2"
                    @click="removeAsignacionLicence(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-attachment-remove</v-icon>
                  </v-btn>
                </template>
                <span>Quitar Licencia</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>

        <!-- <v-container>
                    <s-crud :config="configLicense" title="Licencias" :filter="filterCharacteristicsOrAccessory"
                        noSearch close add edit @save="saveLicense($event)" @close="dialogLicense = false"
                        ref="scrudLicense">
                        <template v-slot="props">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" class="s-col-form" md="4">
                                        <s-select-definition :def="1545" label="Licencia"
                                            v-model="props.item.TelLicence" :add="$fun.isAdmin()" />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="4">
                                        <s-select-definition :def="1546" label="Año" v-model="props.item.TelAnio"
                                            :add="$fun.isAdmin()" />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="4">
                                        <s-date v-model="props.item.TelExpirationDate" label="Fecha Expiración" />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="4">
                                        <s-text label="Correo" v-model="props.item.TelEmail" type="text" />
                                    </v-col>
                                    <v-col cols="12" class="s-col-form" md="12">
                                        <s-textarea :disabled="props.item.EayID ? true : false" label="Observación"
                                            v-model="props.item.TelObservation" />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>

                        <template v-slot:item.TelExpirationDate="{ item }">
                            <p class="pa-0 ma-0">
                                {{ $fun.formatDateView(item.TelExpirationDate) }}
                            </p>
                            <v-chip x-small :color="isExpired(item) ? 'error' : 'success'"
                                class="pa-3 rounded-xl pl-2 pr-2">
                                {{ isExpired(item) ? 'Expirado' : 'Vigente' }}
                            </v-chip>
                        </template>
                    </s-crud>
                </v-container> -->
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialogHistory"
      v-if="dialogHistory"
      max-width="1200px"
    >
      <v-card class="rounded-xl">
        <div class="modern-header">
          <div class="header-content">
            <div class="header-left">
              <v-icon class="header-icon" size="28" color="white"
                >mdi-history</v-icon
              >
              <h2 class="header-title" style="text-transform: uppercase">
                Historial -
                {{ equipoSelected?.CgeTypeEquipmentName }}
                {{ equipoSelected?.CgeBrandName }}
                {{ equipoSelected?.CgeModelName }} -
                {{ equipoSelected?.CgeSerie }}
              </h2>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                large
                class="close-btn"
                @click="dialogHistory = false"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <v-container class="pa-0 pb-3">
          <v-data-table
            :headers="headersEquipmentAssignament"
            :items="filtereditemsEquipmentAssignament"
            dense
            class="modern-table"
            :items-per-page="10"
            item-key="EadID"
          >
            <template v-slot:item.SecCreate="{ item }">
              <span class="date-chip">
                {{ $fun.formatDateView(item.SecCreate) }}
              </span>
            </template>

            <template v-slot:item.PrsDocumentNumber="{ item }">
              <v-chip
                v-if="item.PrsDocumentNumber"
                small
                color="grey lighten-4"
                text-color="grey darken-3"
                class="font-mono primary--text"
              >
                <v-icon x-small size="4" left>mdi-card-account-details</v-icon>
                {{ item.PrsDocumentNumber }}
              </v-chip>
            </template>
            <template v-slot:item.EanObservation="{ item }">
              <p class="truncate-single">
                {{ item.EanObservation }}
              </p>
            </template>
            <template v-slot:item.AsgSecStatus="{ item }">
              <v-chip
                x-small
                :color="item.AsgSecStatus == 1 ? 'success' : 'error'"
                class="pl-2 pr-2"
              >
                {{ item.AsgSecStatus == 1 ? "Activo" : "Inactivo" }}
              </v-chip>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialogUnassignament"
      v-if="dialogUnassignament"
      max-width="400px"
    >
      <v-card class="rounded-xl">
        <div class="modern-header">
          <div class="header-content">
            <div class="header-left">
              <v-icon class="header-icon" size="28" color="white"
                >mdi-link-off</v-icon
              >
              <h2
                class="header-title"
                style="text-transform: uppercase; font-size: 1.2rem"
              >
                Devolución de Accesorio
              </h2>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                large
                class="close-btn"
                @click="dialogUnassignament = false"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <v-col>
          <v-row>
            <v-col cols="12" class="s-col-form">
              <s-select-definition
                :def="1593"
                :add="$fun.isAdmin()"
                label="Estado Devolución"
                clearable
                v-model="formAccDevolution.EayStateDevolution"
              />
            </v-col>
            <v-col cols="12">
              <s-textarea
                label="Observación"
                v-model="formAccDevolution.AahObservation"
                :rows="1"
              />
            </v-col>
          </v-row>
          <v-row justify="end" align="center">
            <v-card-actions>
              <v-btn
                class="rounded-lg"
                color="primary"
                @click="saveDevolutionAccessory"
                >Desvincular</v-btn
              >
            </v-card-actions>
          </v-row>
        </v-col>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialogReturnSupplier"
      v-if="dialogReturnSupplier"
      max-width="700px"
    >
      <v-card class="rounded-xl">
        <div class="modern-header">
          <div class="header-content">
            <div class="header-left">
              <v-icon class="header-icon" size="28" color="white"
                >mdi-truck-delivery</v-icon
              >
              <h2
                class="header-title"
                style="text-transform: uppercase; font-size: 1.2rem"
              >
                Devolución a Proveedor
              </h2>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                large
                class="close-btn"
                @click="dialogReturnSupplier = false"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <v-container class="pa-4">
          <v-row class="mb-1" no-gutters>
            <!-- Equipment card -->
            <v-col cols="12" sm="6" class="pr-sm-2">
              <div class="rs-equip fill-height">
                <div class="rs-equip__icon">
                  <v-icon size="22" color="deep-orange darken-1"
                    >mdi-laptop</v-icon
                  >
                </div>
                <div class="rs-equip__info">
                  <p class="rs-equip__name ma-0">
                    {{ formReturnSupplier.CgeTypeEquipmentName }}
                    <span class="rs-equip__brand"
                      >{{ formReturnSupplier.CgeBrandName }}
                      {{ formReturnSupplier.CgeModelName }}</span
                    >
                  </p>
                  <p class="rs-equip__serie ma-0">
                    <v-icon x-small color="grey darken-1" class="mr-1"
                      >mdi-barcode</v-icon
                    >
                    Serie: <strong>{{ formReturnSupplier.CgeSerie }}</strong>
                  </p>
                </div>
              </div>
            </v-col>

            <!-- Status banner -->
            <v-col cols="12" sm="6" class="pl-sm-2 mt-2 mt-sm-0">
              <div
                v-if="formReturnSupplier.ReturnDateSaved"
                class="rs-status rs-status--done fill-height"
              >
                <div class="rs-status__icon">
                  <v-icon size="20" color="white">mdi-check-circle</v-icon>
                </div>
                <div class="rs-status__body">
                  <span class="rs-status__label">Estado</span>
                  <p class="rs-status__value ma-0">Devuelto al proveedor</p>
                </div>
                <div class="rs-status__date">
                  <v-icon x-small class="mr-1" color="white"
                    >mdi-calendar-check</v-icon
                  >
                  {{ $fun.formatDateView(formReturnSupplier.ReturnDateSaved) }}
                </div>
              </div>
              <div v-else class="rs-status rs-status--pending fill-height">
                <div class="rs-status__icon">
                  <v-icon size="20" color="#7c4a00"
                    >mdi-clock-alert-outline</v-icon
                  >
                </div>
                <div class="rs-status__body">
                  <span class="rs-status__label">Estado</span>
                  <p class="rs-status__value ma-0">Pendiente de devolución</p>
                </div>
                <div class="rs-status__pill">PENDIENTE</div>
              </div>
            </v-col>
          </v-row>

          <!-- Supplier / Customer (read-only, pre-loaded from equipment) -->
          <v-row>
            <v-col cols="12" class="s-col-form">
              <s-text
                label="Proveedor"
                v-model="formReturnSupplier.CustomerName"
                disabled
              />
            </v-col>
          </v-row>

          <!-- Rental period dates -->
          <v-row>
            <v-col cols="12" lg="4" md="6" class="s-col-form">
              <s-date
                v-model="formReturnSupplier.StartDate"
                label="Fecha Inicio Alquiler"
              />
            </v-col>
            <v-col cols="12" lg="4" md="6" class="s-col-form">
              <s-date
                v-model="formReturnSupplier.EndDate"
                label="Fecha Fin Alquiler"
              />
            </v-col>
            <v-col cols="12" lg="4" md="6" class="s-col-form">
              <s-date
                v-model="formReturnSupplier.ReturnDate"
                label="Fecha de Devolución"
                clearable
              />
            </v-col>
          </v-row>

          <!-- Description -->
          <v-row>
            <v-col cols="12">
              <s-textarea
                label="Descripción de Devolución"
                v-model="formReturnSupplier.ReturnDescription"
                :rows="3"
              />
            </v-col>
          </v-row>

          <v-row
            justify="end"
            align="center"
            v-if="[1, 4].includes(formReturnSupplier.CgeStatus)"
          >
            <v-card-actions>
              <v-btn
                class="rounded-lg"
                color="primary"
                @click="saveReturnSupplier()"
              >
                <v-icon left>mdi-content-save</v-icon>
                Registrar Devolución
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialogReturnEmailWarehouse"
      v-if="dialogReturnEmailWarehouse"
      max-width="900px"
    >
      <v-card class="rounded-xl">
        <div class="modern-header">
          <div class="header-content">
            <div class="header-left">
              <v-icon class="header-icon" size="28" color="white"
                >mdi-email-arrow-right</v-icon
              >
              <h2
                class="header-title"
                style="text-transform: uppercase; font-size: 1.2rem"
              >
                Notificar Devoluciones a Almacén
              </h2>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                large
                class="close-btn"
                @click="cancelReturnEmailWarehouse"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <v-container class="pa-4">
          <v-row class="mb-2" align="center">
            <v-col>
              <p class="mb-0 text-body-2 grey--text text--darken-2">
                Seleccione los equipos a notificar. Todos los equipos devueltos al proveedor aparecen preseleccionados por defecto.
              </p>
            </v-col>
            <v-col cols="auto">
              <v-chip small color="primary" outlined class="px-2">
                {{ emailWarehouseSelected.length }} seleccionados
              </v-chip>
            </v-col>
          </v-row>

          <v-data-table
            v-model="emailWarehouseSelected"
            :headers="emailWarehouseHeaders"
            :items="emailWarehouseItems"
            show-select
            item-key="CgeID"
            dense
            :items-per-page="15"
            class="modern-table"
          >
            <template v-slot:item.CgeSerie="{ item }">
              <span class="font-weight-medium monospace-text">{{ item.CgeSerie }}</span>
            </template>
          </v-data-table>

          <v-row justify="end" class="mt-4">
            <v-card-actions>
              <v-btn
                class="rounded-lg"
                color="grey"
                @click="cancelReturnEmailWarehouse"
              >
                Cancelar
              </v-btn>
              <v-btn
                class="rounded-lg"
                color="primary"
                :loading="sendingEmail"
                :disabled="emailWarehouseSelected.length === 0"
                @click="confirmReturnEmailWarehouse"
              >
                <v-icon left>mdi-email-arrow-right</v-icon>
                Enviar Notificación
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialogIncidences"
      v-if="dialogIncidences"
      max-width="1000px"
    >
      <v-card class="rounded-xl">
        <div class="modern-header">
          <div class="header-content">
            <div class="header-left">
              <v-icon class="header-icon" size="28" color="white"
                >mdi-alert-circle-outline</v-icon
              >
              <h2
                class="header-title"
                style="text-transform: uppercase; font-size: 1.2rem"
              >
                INCIDENCIAS - {{ selectedEquipment?.CgeTypeEquipmentName }}
                {{ selectedEquipment?.CgeBrandName }}
                {{ selectedEquipment?.CgeSerie }}
              </h2>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                large
                class="close-btn"
                @click="dialogIncidences = false"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <v-container class="pa-4">
          <v-data-table
            :headers="headersIncidences"
            :items="itemsIncidences"
            :loading="loadingIncidences"
            dense
            :items-per-page="15"
            class="modern-table"
            no-data-text="No se encontraron incidencias para este equipo"
          >
            <template v-slot:item.TskRequestDate="{ item }">
              {{ $fun.formatDateView(item.TskRequestDate) }}
            </template>
            <template v-slot:item.TypeIntervention="{ item }">
              <v-chip x-small color="primary" text-color="white" class="px-2">
                Intervención
              </v-chip>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import SText from "../../../components/Utils/SText.vue";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import TicEquipment from "@/services/InformationTechnology/TicEquipmentService";
import TicEquipmentCharacteristic from "@/services/InformationTechnology/EquimentCharacteristicService";
import TicEquimentAccessoryService from "../../../services/InformationTechnology/EquimentAccessoryService";
import TicEquipmentLicenseService from "../../../services/InformationTechnology/TicEquipmentLicenseService";
import SSupplier from "../../../components/Utils/Logistics/SSupplier.vue";
import GenEmailService from "../../../services/General/GenEmailService";
import TaskService from "../../../services/InformationTechnology/TaskService";
import EquipmentModelService from "../../../services/InformationTechnology/EquipmentModelService";

export default {
  components: {
    SText,
    sToolbarPerson,
    SSupplier,
  },
  data() {
    return {
      CELLPHONE_TYPE_ID: 8,
      loading: false,
      dialogExcel: true,
      openMass: false,
      CgeIDGroup: 0,
      CgeAssigns: true,
      dialogCharacteristics: false,
      characteristicTemplateMap: {
        1: [
          { label: 'Fabricante', key: 'manufacturer' },
          { label: 'Modelo', key: 'model' },
          { label: 'Velocidad', key: 'speed' },
          { label: 'Generación', key: 'generation' }
        ],
        2: [
          { label: 'Tipo', key: 'type' },
          { label: 'Capacidad', key: 'capacity' },
          { label: 'Frecuencia', key: 'frequency' }
        ],
        3: [
          { label: 'Tipo', key: 'type', defaultValue: 'SSD' },
          { label: 'Capacidad', key: 'capacity' },
          { label: 'Formato', key: 'format' }
        ],
        4: [
          { label: 'Tipo', key: 'type', defaultValue: 'HDD' },
          { label: 'Capacidad', key: 'capacity' },
          { label: 'Formato', key: 'format' }
        ],
        5: [
          { label: 'Tipo', key: 'type', defaultValue: 'SSD' },
          { label: 'Capacidad', key: 'capacity' },
          { label: 'Formato', key: 'format' }
        ],
        6: [
          { label: 'Tipo', key: 'type' },
          { label: 'Capacidad', key: 'capacity' },
          { label: 'Formato', key: 'format' }
        ]
      },
      dynamicDetails: {},
      initializingDetails: false,
      lastEctID: -1,
      previousCharacteristic: null,
      dialogAccessory: false,
      dialogLicense: false,
      showAddLicense: false,
      dialogHistory: false,
      showAddAccessory: false,
      dialogUnassignament: false,
      dialogReturnSupplier: false,
      dialogIncidences: false,
      itemsIncidences: [],
      loadingIncidences: false,
      selectedEquipment: {},
      sendingEmail: false,
      equipmentModels: [],
      showAddModelInput: false,
      newModelName: '',
      dialogReturnEmailWarehouse: false,
      emailWarehouseItems: [],
      emailWarehouseSelected: [],
      returnEmailCC: [
        "soporte@sunshineperu.com",
        "logistica@sunshineperu.com",
        // "rpasache@sunshineperu.com",
        // "lancajima@sunshineperu.com",
        // "eflores@sunshineperu.com",
        // "drivas@sunshineperu.com",
      ],
      equipoSelected: {},
      TelID: null,
      EayID: null,
      formHistory: {},
      formAccDevolution: {},
      formReturnSupplier: {},
      formEquipment: {},
      filter: {
        CgeDateFrom: null,
        CgeDateUntil: null,
        CgeTypeAssigns: null,
        AreID: null,
        CgeStatus: null,
        EanZone: null,
        CgeTypeTenure: null,
        CgeTypeEquipment: null,
        CgeID: null,
      },
      filterCharacteristicsOrAccessory: {
        CgeID: "",
      },
      config: {
        service: TicEquipment,
        model: {
          CgeID: "ID",
          CgeDate: "date",
          SecCreate: "date",
          AsgCharacteristicsOrAccessory: "",
          AsgCgeAssigns: "",
          AsgStatusName: "",
          AsgCgeIDAnt: "",
          CustomerId: "",
          CustomerName: "",
          SupplierObj: "object",
        },
        headers: [
          { text: "ID", value: "CgeID", draggable: false, sortable: true },
          {
            text: "Nombre del Equipo",
            value: "CgeTypeEquipmentName",
            width: 120,
            sortable: true,
          },
          { text: "Marca", value: "CgeBrandName", sortable: true },
          {
            text: "Modelo",
            value: "CgeModelName",
            align: "center",
            width: 100,
            sortable: true,
          },
          { text: "Serie", value: "CgeSerie", align: "center", sortable: true },
          {
            text: "Hostname",
            value: "CgeHostname",
            align: "center",
            width: 120,
            sortable: true,
          },
          {
            text: "AnyDesk",
            value: "CgeAnydesk",
            align: "center",
            sortable: true,
          },
          {
            text: "Tipo Tenencia",
            value: "CgeTypeTenureText",
            align: "center",
            sortable: true,
          },
          {
            text: "Proveedor",
            value: "CustomerName",
            align: "center",
            sortable: true,
          },
          {
            text: "Fecha\n Adquisición",
            value: "CgeDate",
            width: 80,
            align: "center",
            sortable: true,
          },
          {
            text: "Asignable a",
            value: "CgeTypeAssignsName",
            align: "center",
            sortable: true,
          },
          {
            text: "Estado Asignación",
            value: "AsgCgeAssigns",
            width: 100,
            draggable: false,
            align: "center",
            sortable: false,
          },
          {
            text: "Estado",
            value: "AsgStatusName",
            width: 80,
            align: "center",
            draggable: false,
            sortable: true,
          },
          {
            text: "¿Anterior?",
            value: "AsgCgeIDAnt",
            align: "center",
            width: 80,
            sortable: true,
          },
          {
            text: "Fecha\n Registro",
            value: "SecCreate",
            width: 80,
            align: "center",
            sortable: true,
          },
          // { text: "Asignación Anterior", value: "NtpFullNameLast", align: "center", width: 140 },
          {
            text: "Agregar",
            value: "AsgCharacteristicsOrAccessory",
            align: "center",
            width: 160,
            draggable: false,
            sortable: false,
          },
          {
            text: "Correo",
            value: "AsgEmailReturnSupplier",
            align: "center",
            width: 70,
            draggable: false,
            sortable: false,
          },
        ],
      },
      configCharacteristics: {
        service: TicEquipmentCharacteristic,
        model: {
          EctID: "ID",
          EctDate: "date",
        },
        headers: [
          { text: "Nombre", value: "EctCharacteristicsName" },
          { text: "Valor", value: "EctValueCharacteristics" },
          { text: "Fecha Adquisición", value: "EctDate" },
        ],
      },
      headerDetail: [
        { text: "VALOR", value: "VALOR_EQUIPO", width: 60 },
        { text: "NOMBRE EQUIPO", value: "NOMBRE_EQUIPO", width: 60 },
        { text: "VALOR", value: "VALOR_MARCA", width: 60 },
        { text: "MARCA", value: "MARCA", width: 60 },
        { text: "MODELO", value: "MODELO", width: 60 },
        { text: "SERIE", value: "SERIE", width: 60 },
        { text: "FECHA ADQUISION", value: "FECHA_ADQUISION", width: 60 },
        { text: "ASIGNABLE A", value: "ASIGNABLE_A", width: 60 },
        { text: "ASIGNABLE", value: "ASIGNABLE", width: 60 },
      ],
      headers: [
        { column: "VALOR_EQUIPO", value: "VALOR_EQUIPO", text: "VALOR" },
        {
          column: "NOMBRE_EQUIPO",
          value: "NOMBRE_EQUIPO",
          text: "NOMBRE DEL EQUIPO",
        },
        { column: "VALOR_MARCA", value: "VALOR_MARCA", text: "VALOR" },
        { column: "MARCA", value: "MARCA", text: "MARCA" },
        { column: "MODELO", value: "MODELO", text: "MODELO" },
        { column: "SERIE", value: "SERIE", text: "SERIE" },
        {
          column: "FECHA_ADQUISION",
          value: "FECHA_ADQUISION",
          text: "FECHA ADQUISION",
          date: true,
        },
        { column: "ASIGNABLE_A", value: "ASIGNABLE_A", text: "ASIGNABLE A" },
        { column: "ASIGNABLE", value: "ASIGNABLE", text: "ASIGNABLE" },
        {
          column: "TIPO_TENENCIA",
          value: "TIPO_TENENCIA",
          text: "TIPO TENENCIA",
        },
      ],
      configAccessory: {
        service: TicEquimentAccessoryService,
        model: {
          EayID: "ID",
        },
        headers: [
          { text: "Nombre", value: "EayAccessoryName" },
          { text: "Marca", value: "EayBrandName", width: 120 },
          { text: "Modelo", value: "EayModelName", width: 120 },
          { text: "Serie", value: "EaySerie", width: 120 },
          { text: "Estado", value: "EayState", width: 70, align: "center" },
        ],
      },
      configLicense: {
        service: TicEquipmentLicenseService,
        model: {
          TelID: "ID",
          TelExpirationDate: "date",
          TelEmail: "string",
        },
        headers: [
          { text: "Nombre", value: "TelLicenceName" },
          { text: "Año", value: "TelAnioName" },
          { text: "Expiración", value: "TelExpirationDate", align: "center" },
          { text: "Correo", value: "TelEmail" },
          { text: "Observación", value: "TelObservation" },
        ],
      },
      headersEquipmentAssignament: [
        {
          text: "ID",
          value: "EadID",
          align: "center",
          width: 70,
          draggable: false,
        },
        { text: "Registrado", value: "SecCreate", align: "center", width: 100 },
        { text: "Hostname", value: "EanHostName", width: 100, align: "center" },
        {
          text: "AnyDesk",
          value: "EanNumAnydesk",
          width: 100,
          align: "center",
        },
        {
          text: "Tipo Asignación",
          value: "CgeTypeAssignsName",
          align: "center",
          width: 100,
        },
        { text: "Area", value: "AreName", width: 120, align: "center" },
        { text: "DNI", value: "PrsDocumentNumber", width: 90, align: "center" },
        { text: "Apellidos y Nombres", value: "NtpFullName", width: 150 },
        {
          text: "Observaciones",
          value: "EanObservation",
          align: "justify",
          draggable: false,
        },
        {
          text: "Estado",
          value: "AsgSecStatus",
          align: "center",
          width: 100,
          draggable: false,
        },
      ],
      filtereditemsEquipmentAssignament: [],
      itemsLicenseAvailables: [],
      itemsLicenceHistory: [],
      headersLicenceHistory: [
        { text: "ID", value: "TlhID", width: "40" },
        {
          text: "Licencia",
          value: "TelLicenceName",
          width: "160",
          sortable: false,
        },
        {
          text: "Edición",
          value: "TelEditionName",
          width: "100",
          sortable: false,
        },
        { text: "Serial", value: "TelSerial", width: "100", sortable: false },
        { text: "Correo", value: "TelEmail", width: "100", sortable: false },
        {
          text: "Vencimiento",
          value: "TelExpirationDate",
          width: "80",
          sortable: false,
        },
        {
          text: "Estado",
          value: "Status",
          width: "70",
          align: "center",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "TelOptions",
          width: "70",
          align: "center",
          sortable: false,
        },
        // { text: "Vinculado", value: "SecCreate", width: "70" },
      ],
      itemsAccesoryAvailables: [],
      itemsAccesoryHistory: [],
      emailWarehouseHeaders: [
        { text: "ID", value: "CgeID", width: 60 },
        { text: "Tipo", value: "CgeTypeEquipmentName", width: 120 },
        { text: "Marca", value: "CgeBrandName", width: 100 },
        { text: "Modelo", value: "CgeModelName", width: 100 },
        { text: "Serie", value: "CgeSerie", width: 120 },
      ],
      headersIncidences: [
        { text: "Id", value: "TskID", width: 60 },
        { text: "Fecha", value: "TskRequestDate", width: 110 },
        { text: "Tipo de Intervención", value: "TypeIntervention", width: 130 },
        { text: "Atendido por", value: "AssignedPersonName", width: 170 },
        { text: "Descripción", value: "TskTitle" },
        { text: "Solución", value: "TskDescription" },
      ],
      headersAccesoryHistory: [
        { text: "ID", value: "EayID", sortable: false, width: "40" },
        { text: "Nombre", value: "EayAccessoryName", sortable: false },
        { text: "Marca", value: "EayBrandName", width: 120, sortable: false },
        { text: "Modelo", value: "EayModelName", width: 120, sortable: false },
        { text: "Serie", value: "EaySerie", width: 120, sortable: false },
        {
          text: "Estado",
          value: "EayState",
          width: 70,
          align: "center",
          sortable: false,
        },
        {
          text: "Liberar",
          value: "EayOptions",
          width: "70",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    dynamicDetails: {
      deep: true,
      handler(newVal) {
        if (this.initializingDetails) return;
        if (this.$refs.scrudCharacteristics && this.$refs.scrudCharacteristics.row) {
          const item = this.$refs.scrudCharacteristics.row;
          const template = this.characteristicTemplateMap[item.EctCharacteristics];
          if (template) {
            const values = [];
            template.forEach(field => {
              const val = newVal[field.key];
              if (val !== undefined && val !== null && val !== "") {
                values.push(val);
              }
            });
            item.EctValueCharacteristics = values.join(" - ");
          }
        }
      }
    }
  },
  methods: {
    validarAnydesk() {
      let value = this.$refs.CgeAnydesk.$el.querySelector("input").value.trim();
      if (!/^\d+$/.test(value)) {
        return false;
      }
    },
    validatedItems(item) {
      if (!item.EayBrand && !item.EayModel && !item.EaySerie) {
        return true;
      } else {
        return false;
      }
    },
    onAddEvent() {
      this.$nextTick(() => {
        const crud = this.$refs.scrudEquipment;
        if (crud && crud.formItem) {
          crud.formItem.CustomerId = null;
          crud.formItem.CustomerName = null;
          this.$set(crud.formItem, "SupplierObj", null);
        }
      });
    },
    onEditEvent(item) {
      this.CgeAssigns = item.CgeAssigns == 0 ? false : true;
      if (item.CustomerId) {
        this.$set(item, "SupplierObj", {
          SupID: item.CustomerId,
          SupName: item.CustomerName || "",
        });
      } else {
        this.$set(item, "SupplierObj", null);
      }
    },
    save(item) {
      item.UsrCreateID = this.$fun.getUserID();
      item.CgeAssigns = this.CgeAssigns ? 1 : 0;
      item.CgeSerie = this.$fun.trimFull(item.CgeSerie, true);

      if (!item.CgeID) {
        item.CgeStatus = 1;
      }
      // console.log("Save:",item);
      if (item.CgeModel == "") {
        this.$fun.alert("Ingresar modelo del equipo", "warning");
        return;
      }
      if (item.CgeSerie.trim() == "") {
        this.$fun.alert("Ingresar serie del equipo", "warning");
        return;
      }

      if (item.CgeTypeTenure == 2 && (!item.CustomerId || item.CustomerId == "")) {
        this.$fun.alert("Seleccione un proveedor para el equipo alquilado", "warning");
        return;
      }

      if (item.CgeTypeTenure != 2) {
        item.CustomerId = null;
      }

      if (item.CgeAnydesk != "") {
        // Accepts AnyDesk IDs (8+ digits) or IP addresses (e.g. 192.168.1.1)
        const regexAnydesk = /^\d{8,}$/;
        const regexIP = /^(25[0-5]|2[0-4]\d|1?\d?\d)(\.(25[0-5]|2[0-4]\d|1?\d?\d)){3}$/;
        if (!regexAnydesk.test(item.CgeAnydesk) && !regexIP.test(item.CgeAnydesk)) {
          this.$fun.alert(
            "Por favor ingresa una dirección Anydesk o IP válida",
            "warning",
          );
          return;
        }
      }
      item.save();
    },
    AsgCharacteristics(row) {
      this.filterCharacteristicsOrAccessory.CgeID = row.CgeID;
      this.CgeIDGroup = row.DedHelper2 ? parseInt(row.DedHelper2) : 0;
      this.dialogCharacteristics = true;
    },
    saveCharacteristics(item) {
      const template = this.characteristicTemplateMap[item.EctCharacteristics];
      if (template) {
        const values = [];
        template.forEach(field => {
          const val = this.dynamicDetails[field.key];
          if (val) {
            values.push(val);
          }
        });
        if (values.length > 0) {
          item.EctValueCharacteristics = values.join(" - ");
        }
        item.EctDetailsJSON = JSON.stringify(this.dynamicDetails);
      } else {
        item.EctDetailsJSON = null;
      }

      if (item.EctValueCharacteristics == "") {
        this.$fun.alert("Ingresar valor de la característica", "warning");
        return;
      }
      item.UsrCreateID = this.$fun.getUserID();
      item.CgeID = this.filterCharacteristicsOrAccessory.CgeID;
      item.save();
    },
    initializeDetails(item) {
      if (!item || item.EctID === this.lastEctID) return;
      this.lastEctID = item.EctID;

      this.initializingDetails = true;

      this.previousCharacteristic = item.EctCharacteristics != null ? String(item.EctCharacteristics) : null;

      let parsed = {};
      if (item.EctDetailsJSON) {
        try {
          parsed = JSON.parse(item.EctDetailsJSON);
        } catch (e) {
          console.error("Error parsing EctDetailsJSON:", e);
        }
      }

      const nextDetails = {};
      const template = this.characteristicTemplateMap[item.EctCharacteristics];
      if (template) {
        template.forEach(field => {
          const key = field.key;
          nextDetails[key] = (parsed && parsed[key] !== undefined) ? parsed[key] : (field.defaultValue || "");
        });
      }
      this.dynamicDetails = nextDetails;

      this.$nextTick(() => {
        this.initializingDetails = false;
      });
    },
    hasDynamicFields(ectCharacteristics) {
      return !!this.characteristicTemplateMap[ectCharacteristics];
    },
    onCharacteristicChange(val) {
      // Guard against non-primitive values emitted by s-select-generic.load() (e.g., items array)
      if (val === undefined || val === null || typeof val === 'object') return;

      if (String(val) === String(this.previousCharacteristic)) return;

      // Guard against invalid IDs (NaN values pass through from s-select-generic internals)
      if (isNaN(Number(val))) return;

      this.initializingDetails = true;
      this.previousCharacteristic = val;

      const nextDetails = {};
      const template = this.characteristicTemplateMap[val];
      if (template) {
        template.forEach(field => {
          const key = field.key;
          nextDetails[key] = field.defaultValue !== undefined ? field.defaultValue : "";
        });
      }
      this.dynamicDetails = nextDetails;

      this.$nextTick(() => {
        this.initializingDetails = false;
      });
    },
    clearCharacteristicForm() {
      this.initializingDetails = true;
      this.lastEctID = -1;
      this.previousCharacteristic = null;
      this.dynamicDetails = {};
      this.$nextTick(() => {
        this.initializingDetails = false;
      });
    },
    onCharacteristicEdit(item) {
      if (item) {
        this.initializeDetails(item);
      }
    },
    onCharacteristicEditFormOpen() {
      this.$nextTick(() => {
        const crud = this.$refs.scrudCharacteristics;
        if (crud && crud.row && crud.row.EctID) {
          this.initializeDetails(crud.row);
        }
      });
    },
    AsgHistoryAssignaments(row) {
      this.equipoSelected = row;
      TicEquipment.history(row.CgeID, this.$fun.getUserID()).then((resp) => {
        if (resp.status == 200) {
          this.filtereditemsEquipmentAssignament = resp.data;
          if (resp.data.length > 0) {
            this.dialogHistory = true;
          }
        }
      });
    },
    openMassRegistrations() {
      this.openMass = true;
    },
    clear() {
      this.dialogExcel = false;
      setTimeout(() => {
        this.dialogExcel = true;
      }, 10);
    },
    async saveMassive(items) {
      let itemsCount = items.length;
      let count = 0;

      // console.log("items", items);
      if (items.length == 0) {
        this.$fun.alert("No hay datos para registrar", "warning");
        return;
      }
      if (this.loading) {
        this.$fun.alert("Procesando datos", "warning");
        return;
      }

      this.loading = true;

      for (const item of items) {
        const equipment = {
          CgeTypeEquipment: item.VALOR_EQUIPO,
          CgeTypeAssigns: item.ASIGNABLE_A,
          CgeBrand: item.VALOR_MARCA,
          CgeModel: item.MODELO,
          CgeSerie: item.SERIE
            ? this.$fun.trimFull(item.SERIE.toString(), true)
            : "",
          CgeAssigns: item.ASIGNABLE,
          CgeDate: item.FECHA_ADQUISION,
          CgeTypeTenure: item.TIPO_TENENCIA,
          UsrCreateID: this.$fun.getUserID(),
          CgeStatus: 1,
        };

        if (equipment.CgeSerie == "") {
          this.$fun.alert("Debe de llenar la serie", "warning");
          return;
        }

        try {
          // console.log(equipment);
          const response = await TicEquipment.save(
            equipment,
            this.$fun.getUserID(),
          );
          if (response.status == 200) {
            count++;
          }
          // console.log("Registro de Persona", response.data);
        } catch (error) {
          console.error("Error al registrar persona ", item, error);
        }
      }

      this.loading = false;
      if (itemsCount != count) {
        this.$fun.alert("No se pudo registrar todos los equipos", "warning");
      } else {
        this.$fun.alert("Guardado Correctamente", "success");
      }
      this.$refs.scrudEquipment.refresh();
      this.openMass = false;
    },
    AsgAccessory(row) {
      this.formEquipment = { ...row };
      this.showAddAccessory = false;
      this.filterCharacteristicsOrAccessory.CgeID = row.CgeID;
      this.loadDevicesHistoryAccesory(() => {
        this.listAccessoriesAvailables(() => (this.dialogAccessory = true));
      });
    },
    saveAccessory(item) {
      item.UsrCreateID = this.$fun.getUserID();
      item.CgeID = this.filterCharacteristicsOrAccessory.CgeID;

      if (item.EayState == "" || !item.EayState > 0) {
        this.$fun.alert("Seleccionar estado del Accesorio", "warning");
        return;
      }
      item.save();
    },
    AsgLicense(row) {
      this.formHistory = row;
      this.filterCharacteristicsOrAccessory.CgeID = row.CgeID;
      console.log(row);
      this.TelID = null;
      this.showAddLicense = false;
      this.loadDevicesHistoryLicence(() => {
        this.listLicencesAvailables();
        this.dialogLicense = true;
      });
    },
    saveLicense(item) {
      item.UsrCreateID = this.$fun.getUserID();
      item.CgeID = this.filterCharacteristicsOrAccessory.CgeID;
      item.TelStatus = 1;
      item.save();
    },
    isExpired(item) {
      const today = new Date();
      const expirationDate = new Date(item.TelExpirationDate);
      return expirationDate < today;
    },
    loadDevicesHistoryLicence(callback = () => {}) {
      const filters = { CgeID: this.filterCharacteristicsOrAccessory.CgeID };
      TicEquipmentLicenseService.listDevicesHistory(
        filters,
        this.$fun.getUserID(),
      ).then((response) => {
        this.itemsLicenceHistory = response.status == 200 ? response.data : [];
        callback();
      });
    },
    removeAsignacionLicence(history) {
      this.$fun
        .alert("Quitar licencia del equipo seleccionado ?", "question")
        .then((res) => {
          if (res.value) {
            const values = {
              TlhID: history.TlhID,
              TelID: history.TelID,
              CgeID: history.CgeID,
              EndDate: new Date(),
              Status: 0,
              UsrCreateID: this.$fun.getUserID(),
            };
            this.saveOrUpdateHistoryLicence(values);
          }
        });
    },
    saveAsignacionLicence() {
      if (this.formHistory.CgeID == null) {
        this.$fun.alert("Seleccione un equipo", "info");
        return;
      }

      if (this.TelID == null || this.TelID == "") {
        this.$fun.alert("Seleccione una licencia", "info");
        return;
      }

      this.$fun
        .alert("Asignar Licencia al equipo seleccionado ?", "question")
        .then((res) => {
          if (res.value) {
            const values = {
              TlhID: 0,
              TelID: this.TelID,
              CgeID: this.formHistory.CgeID,
              EndDate: null,
              Status: 1,
              UsrCreateID: this.$fun.getUserID(),
            };
            this.saveOrUpdateHistoryLicence(values, () => (this.TelID = null));
          }
        });
    },
    saveOrUpdateHistoryLicence(history, callback = () => {}) {
      TicEquipmentLicenseService.SaveHistoryLicense(
        history,
        this.$fun.getUserID(),
      ).then((response) => {
        if (response.status == 200) {
          this.$fun.alert(
            history.Status == 0
              ? "Licencia quitada del equipo"
              : "Licencia asignada al equipo",
            "success",
          );
          this.loadDevicesHistoryLicence(callback);
        }
      });
    },
    listLicencesAvailables(filters = {}) {
      TicEquipmentLicenseService.list(filters, this.$fun.getUserID()).then(
        (response) => {
          this.itemsLicenseAvailables =
            response.status == 200 ? response.data : [];
        },
      );
    },
    loadDevicesHistoryAccesory(callback = () => {}) {
      const CgeID = this.filterCharacteristicsOrAccessory.CgeID;
      TicEquimentAccessoryService.listDevicesHistory(
        { CgeID, OnlyAsigned: 1 },
        this.$fun.getUserID(),
      ).then((resp) => {
        this.itemsAccesoryHistory = resp.status == 200 ? resp.data : [];
        callback();
      });
    },
    listAccessoriesAvailables(callback = () => {}) {
      const params = { EayAccessory: null, Search: "" };
      TicEquimentAccessoryService.list(params, this.$fun.getUserID()).then(
        (resp) => {
          this.itemsAccesoryAvailables =
            resp.status == 200
              ? resp.data.map((item) => ({
                  ...item,
                  EayAccessoryFullName: `${item.EayAccessoryName} ${item.EayPhoneNumber ? ' - ' + item.EayPhoneNumber : ''} ${item.EayObservation} ${item.EayBrandName} ${item.EayModelName} ${item.EaySerie}`,
                }))
              : [];
          callback();
        },
      );
    },
    saveAsignacionAccesory() {
      if (
        this.filterCharacteristicsOrAccessory.CgeID == undefined ||
        this.filterCharacteristicsOrAccessory.CgeID == null ||
        this.filterCharacteristicsOrAccessory.CgeID == ""
      ) {
        this.$fun.alert("Seleccione un equipo", "info");
        return;
      }
      if (this.EayID == null || this.EayID == "") {
        this.$fun.alert("Seleccione un accesorio disponible", "info");
        return;
      }

      this.$fun
        .alert("Asignar Accesorio al equipo seleccionado ?", "question")
        .then((res) => {
          if (res.value) {
            const history = {
              AahcID: 0,
              EayID: this.EayID,
              CgeID: this.filterCharacteristicsOrAccessory.CgeID,
              AahObservation: null,
              EayStatus: null,
              DateDevolution: null,
              SecStatus: 1,
              UsrCreateID: this.$fun.getUserID(),
            };
            this.saveOrUpdateHistoryAccesory([history], () => {
              this.EayID = null;
              this.formEquipment = {};
            });
          }
        });
    },
    removeAsignacionAccesory(item) {
      this.formAccDevolution = { ...item };
      this.dialogUnassignament = true;
      console.log(item);
    },
    saveDevolutionAccessory() {
      if (!this.formAccDevolution.EayStateDevolution > 0) {
        this.$fun.alert("Debe seleccionar un estado de devolución", "info");
        return;
      }

      const history = {
        AahcID: this.formAccDevolution.AahcID,
        EayID: this.formAccDevolution.EayID,
        CgeID: this.formAccDevolution.CgeID,
        EayStatus: this.formAccDevolution.EayStateDevolution,
        AahObservation: this.formAccDevolution.AahObservation,
        DateDevolution: new Date(),
        SecStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
      };
      // console.log(history)
      this.$fun
        .alert("Liberar Accesorio del equipo ?", "question")
        .then((res) => {
          if (res.value) {
            this.saveOrUpdateHistoryAccesory([history], () => {
              this.formAccDevolution.EayStatusAssignament = 0;
              this.formAccDevolution.EayState = null;
              this.dialogUnassignament = false;
            });
          }
        });
    },
    saveOrUpdateHistoryAccesory(history, callback = () => {}) {
      TicEquimentAccessoryService.SaveHistoryAccessory(
        history,
        this.$fun.getUserID(),
      ).then((response) => {
        if (response.status == 200) {
          this.$fun.alert(
            history.EayStatus == null
              ? "Accesorio asignado al equipo"
              : "Accesorio liberado del equipo",
            "success",
          );
          this.loadDevicesHistoryAccesory(callback);
          this.listAccessoriesAvailables();
        }
      });
    },
    openReturnSupplier(row) {
      TicEquipment.TicEquipmentRental(
        { CgeID: row.CgeID },
        this.$fun.getUserID(),
      ).then((response) => {
        if (response.status == 200) {
          const rentalData = response.data && Object.keys(response.data).length > 0 ? response.data : null;
          const customerId = (rentalData && rentalData.CustomerId) ? rentalData.CustomerId : row.CustomerId;
          const customerName = (rentalData && rentalData.CustomerName) ? rentalData.CustomerName : row.CustomerName;
          console.log({ rentalData, customerId, customerName });

          if (rentalData) {
            this.formReturnSupplier = {
              ...row,
              ...rentalData,
              CustomerId: customerId,
              CustomerName: customerName || "Sin proveedor",
              ReturnDateSaved: rentalData.ReturnDate,
            };
          } else {
            this.formReturnSupplier = {
              ...row,
              ErID: 0,
              CgeId: row.CgeID,
              CustomerId: customerId,
              CustomerName: customerName || "Sin proveedor",
              StartDate: this.$fun.getDate(),
              EndDate: "",
              ReturnDate: this.$fun.getDate(),
              ReturnDateSaved: null,
              ReturnDescription: null,
              Status: 1,
              SecStatus: 1,
              UsrCreateID: this.$fun.getUserID(),
            };
          }

          if (!this.formReturnSupplier.ReturnDate) {
            this.formReturnSupplier.ReturnDate = this.$fun.getDate();
          }

          this.dialogReturnSupplier = true;
        }
      });
    },
    async openIncidences(row) {
      this.selectedEquipment = row;
      this.itemsIncidences = [];
      this.dialogIncidences = true;
      this.loadingIncidences = true;
      try {
        const resp = await TaskService.byEquipment(
          row.CgeID,
          this.$fun.getUserID(),
        );
        if (resp.status == 200 && resp.data) {
          this.itemsIncidences = resp.data;
        } else {
          this.itemsIncidences = [];
        }
      } catch (error) {
        console.error("Error loading incidences:", error);
        this.itemsIncidences = [];
      } finally {
        this.loadingIncidences = false;
      }
    },
    onMainSupplierSelected(item, supplier) {
      if (supplier && supplier.SupID) {
        this.$set(item, "CustomerId", String(supplier.SupID));
        this.$set(item, "CustomerName", supplier.SupName);
      } else {
        this.$set(item, "CustomerId", null);
        this.$set(item, "CustomerName", null);
      }
    },
    saveReturnSupplier() {
      if (!this.formReturnSupplier.ReturnDate) {
        this.$fun.alert("Debe seleccionar una fecha de devolución", "warning");
        return;
      }
      // if (!this.formReturnSupplier.ReturnDescription || this.formReturnSupplier.ReturnDescription.trim() === "") {
      //     this.$fun.alert("Debe ingresar una descripción de devolución", "warning");
      //     return;
      // }

      const payload = {
        ErID: this.formReturnSupplier.ErID,
        CgeID: this.formReturnSupplier.CgeID,
        CustomerId: this.formReturnSupplier.CustomerId,
        StartDate: this.formReturnSupplier.StartDate,
        EndDate: this.formReturnSupplier.EndDate,
        ReturnDate: this.formReturnSupplier.ReturnDate,
        ReturnDescription: this.formReturnSupplier.ReturnDescription,
        Status: this.formReturnSupplier.Status || 1,
        SecStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
      };

      const updateEquipment = () => {
        const equipment = { ...this.formReturnSupplier, CgeStatus: 4 };
        console.log({ equipment });
        TicEquipment.save(equipment, this.$fun.getUserID()).then((response) => {
          // console.log(response)
          if (response.status == 200) {
            console.log("Devolución registrada correctamente");
          }
        });
      };

      this.$fun
        .alert("¿Registrar devolución del equipo al proveedor?", "question")
        .then((res) => {
          if (res.value) {
            TicEquipment.TicSaveRental(payload, this.$fun.getUserID()).then(
              (response) => {
                if (response.status == 200) {
                  updateEquipment();

                  TicEquimentAccessoryService.listDevicesHistory(
                    { CgeID: this.formReturnSupplier.CgeID, OnlyAsigned: 1 },
                    this.$fun.getUserID(),
                  ).then((resp) => {
                    const accesories = resp.data.map((x) => {
                      // const EayState = x.EayState;
                      // DateDevolution: this.$fun.getDate()
                      return { ...x, EayState: 7, EayStatus: 7 };
                    });
                    console.log({ accesories });

                    TicEquimentAccessoryService.SaveHistoryAccessory(
                      accesories,
                      this.$fun.getUserID(),
                    ).then((response) => {
                      if (response.status == 200) {
                        this.$fun.alert(
                          "Devolución registrada correctamente",
                          "success",
                        );
                        this.dialogReturnSupplier = false;
                        this.$refs.scrudEquipment.refresh();
                      }
                    });
                    // for (const accesory of accesories) {
                    //     TicEquimentAccessoryService.save(accesory, this.$fun.getUserID()).then((response) => {
                    //         if (response.status == 200) {
                    //             console.log("Estado de Accesorio devuelto proveedor");
                    //         }
                    //     })
                    // }
                  });
                }
              },
            );
          }
        });
    },
    async sendReturnEmailWarehouse() {
      this.sendingEmail = true;
      try {
        const filter = { CgeStatus: 4 };
        const paginationReq = {
          length: -1, start: 0, column: 0, dir: "asc", searchText: "", filter: filter,
        };
        const resp = await TicEquipment.pagination(
          paginationReq,
          this.$fun.getUserID(),
        );
        if (resp.status != 200 || !resp.data || !resp.data.data || resp.data.data.length == 0) {
          this.$fun.alert("No hay equipos devueltos al proveedor", "info");
          this.sendingEmail = false;
          return;
        }

        const equipments = resp.data.data.filter(
          (eq) => !eq.EmailSentWarehouse,
        );
        if (equipments.length == 0) {
          this.$fun.alert("Todos los equipos devueltos ya fueron notificados a Almac&eacute;n.", "info");
          this.sendingEmail = false;
          return;
        }

        this.emailWarehouseItems = equipments;
        this.emailWarehouseSelected = [...equipments];
        this.dialogReturnEmailWarehouse = true;
      } catch (error) {
        console.error("Error loading return email data:", error);
        this.$fun.alert("Error al cargar los equipos devueltos", "error");
      } finally {
        this.sendingEmail = false;
      }
    },
    cancelReturnEmailWarehouse() {
      this.dialogReturnEmailWarehouse = false;
      this.emailWarehouseItems = [];
      this.emailWarehouseSelected = [];
    },
    async confirmReturnEmailWarehouse() {
      if (this.emailWarehouseSelected.length === 0) {
        this.$fun.alert("Seleccione al menos un equipo para notificar", "info");
        return;
      }

      this.sendingEmail = true;
      try {
        const equipments = this.emailWarehouseSelected;

        let tableRows = "";
        let equipmentIndex = 0;
        let supplierName = "";

        for (const eq of equipments) {
          equipmentIndex++;
          let accessories = [];
          let equipmentObs = "";

          try {
            const rentalResp = await TicEquipment.TicEquipmentRental(
              { CgeID: eq.CgeID },
              this.$fun.getUserID(),
            );
            if (rentalResp.status == 200 && rentalResp.data) {
              if (rentalResp.data.CustomerName && !supplierName) {
                supplierName = rentalResp.data.CustomerName;
              }
              equipmentObs = rentalResp.data.ReturnDescription || "";
            }
          } catch (e) {
            console.warn("Could not fetch rental for CgeID", eq.CgeID, e);
          }

          try {
            const accResp = await TicEquimentAccessoryService.listDevicesHistory(
              { CgeID: eq.CgeID, OnlyAsigned: 1 },
              this.$fun.getUserID(),
            );
            if (accResp.status == 200 && accResp.data) {
              accessories = accResp.data;
            }
          } catch (e) {
            console.warn("Could not fetch accessories for CgeID", eq.CgeID, e);
          }

          const totalRows = 1 + accessories.length;

          tableRows += `
            <tr>
              <td style="padding: 12px 8px; border: 1px solid #e0e0e0; text-align: center; vertical-align: middle; font-weight: bold; background-color: #ffffff; color: #2c3e50;" rowspan="${totalRows}">${equipmentIndex}</td>
              <td style="padding: 12px 8px; border: 1px solid #e0e0e0; vertical-align: top; background-color: #ffffff; color: #333;"><strong>${eq.CgeTypeEquipmentName || ""}</strong></td>
              <td style="padding: 12px 8px; border: 1px solid #e0e0e0; vertical-align: top; background-color: #ffffff; color: #333;">${eq.CgeBrandName || ""}</td>
              <td style="padding: 12px 8px; border: 1px solid #e0e0e0; vertical-align: top; background-color: #ffffff; color: #333;">${eq.CgeModelName || ""}</td>
              <td style="padding: 12px 8px; border: 1px solid #e0e0e0; vertical-align: top; background-color: #ffffff; font-family: monospace; color: #2c3e50; font-size: 13px;">${eq.CgeSerie || ""}</td>
              <td style="padding: 12px 8px; border: 1px solid #e0e0e0; vertical-align: top; background-color: #ffffff; color: #666; font-size: 12px;">${equipmentObs}</td>
            </tr>`;

          for (const acc of accessories) {
            const accObs = acc.EayObservation || acc.AahObservation || "";
            tableRows += `
              <tr style="background-color: #fafbfc;">
                <td style="padding: 8px 8px 8px 15px; border: 1px solid #e0e0e0; font-size: 12px; color: #5c6a79;">
                  <span style="color: #bdc3c7; margin-right: 4px;">&#8627;</span> ${acc.EayAccessoryName || ""}
                </td>
                <td style="padding: 8px 8px; border: 1px solid #e0e0e0; font-size: 12px; color: #5c6a79;">${acc.EayBrandName || ""}</td>
                <td style="padding: 8px 8px; border: 1px solid #e0e0e0; font-size: 12px; color: #5c6a79;">${acc.EayModelName || ""}</td>
                <td style="padding: 8px 8px; border: 1px solid #e0e0e0; font-size: 12px; color: #5c6a79; font-family: monospace;">${acc.EaySerie || "N/A"}</td>
                <td style="padding: 8px 8px; border: 1px solid #e0e0e0; font-size: 11px; color: #888; font-style: italic;">${accObs}</td>
              </tr>`;
          }
        }

        const supplierText = supplierName
          ? ` (<strong>${supplierName}</strong>)`
          : "";

        const emailBody = `
          <div style="font-family: 'Segoe UI', Helvetica, Arial, sans-serif; font-size: 14px; color: #333; max-width: 900px; margin: 0 auto; border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.05);">
            <div style="background-color: #2c3e50; padding: 20px 24px; border-bottom: 3px solid #3498db;">
              <h2 style="color: #ffffff; margin: 0; font-size: 18px; letter-spacing: 0.5px;">SUNSHINE PERÚ <span style="color: #3498db; margin: 0 5px;">|</span> TI</h2>
            </div>
            <div style="padding: 30px 24px;">
              <p style="margin-top: 0; color: #2c3e50;">Estimado equipo de <strong>Almacén</strong>,</p>
              <p style="line-height: 1.6; color: #555;">
                A continuación se detalla la relación de equipos y componentes que serán devueltos al proveedor${supplierText}. Por favor, tomar conocimiento para la actualización de sus inventarios.
              </p>

              <table style="border-collapse: collapse; width: 100%; font-size: 13px; margin-top: 24px;">
                <thead>
                  <tr style="background-color: #f1f4f6; color: #2c3e50; text-align: left;">
                    <th style="padding: 12px 8px; border: 1px solid #e0e0e0; border-bottom: 2px solid #cbd5e1; text-align: center; width: 40px;">N°</th>
                    <th style="padding: 12px 8px; border: 1px solid #e0e0e0; border-bottom: 2px solid #cbd5e1;">TIPO</th>
                    <th style="padding: 12px 8px; border: 1px solid #e0e0e0; border-bottom: 2px solid #cbd5e1;">MARCA</th>
                    <th style="padding: 12px 8px; border: 1px solid #e0e0e0; border-bottom: 2px solid #cbd5e1;">MODELO</th>
                    <th style="padding: 12px 8px; border: 1px solid #e0e0e0; border-bottom: 2px solid #cbd5e1;">SERIE</th>
                    <th style="padding: 12px 8px; border: 1px solid #e0e0e0; border-bottom: 2px solid #cbd5e1;">OBSERVACIONES</th>
                  </tr>
                </thead>
                <tbody>
                  ${tableRows}
                </tbody>
              </table>

              <div style="margin-top: 30px; font-size: 12px; color: #999; border-top: 1px solid #eeeeee; padding-top: 15px; text-align: center;">
                Este es un correo automático generado por el Sistema de TI &mdash; Sunshine Perú.<br>Por favor no responder a esta dirección.
              </div>
            </div>
          </div>`;

        const payload = {
          emailTo: "almacen@sunshineperu.com",
          subject: `Equipos Devueltos al Proveedor - ${this.$fun.formatDateView(new Date())}`,
          bodyMail: emailBody,
          emailCC: this.returnEmailCC,
        };

        const emailResp = await GenEmailService.sendEmail(
          payload,
          this.$fun.getUserID(),
        );
        if (emailResp.status == 200) {
          for (const eq of equipments) {
            try {
              await TicEquipment.updateEmailSentWarehouse(eq.CgeID, this.$fun.getUserID());
            } catch (e) {
              console.warn("Could not mark sent for CgeID", eq.CgeID, e);
            }
          }
          this.$refs.scrudEquipment.refresh();
          this.$fun.alert(`Correo enviado a Almac&eacute;n (${equipments.length} equipo(s))`, "success");
          this.cancelReturnEmailWarehouse();
        } else {
          this.$fun.alert("Error al enviar el correo", "error");
        }
      } catch (error) {
        console.error("Error sending return email:", error);
        this.$fun.alert("Error al enviar el correo", "error");
      } finally {
        this.sendingEmail = false;
      }
    },
    async sendSingleReturnEmailWarehouse(item) {
      try {
        let supplierName = "";
        let equipmentObs = "";

        try {
          const rentalResp = await TicEquipment.TicEquipmentRental(
            { CgeID: item.CgeID },
            this.$fun.getUserID(),
          );
          if (rentalResp.status == 200 && rentalResp.data) {
            supplierName = rentalResp.data.CustomerName || "";
            equipmentObs = rentalResp.data.ReturnDescription || "";
          }
        } catch (e) {
          console.warn("Could not fetch rental for CgeID", item.CgeID, e);
        }

        let accessories = [];
        try {
          const accResp = await TicEquimentAccessoryService.listDevicesHistory(
            { CgeID: item.CgeID, OnlyAsigned: 1 },
            this.$fun.getUserID(),
          );
          if (accResp.status == 200 && accResp.data) {
            accessories = accResp.data;
          }
        } catch (e) {
          console.warn("Could not fetch accessories for CgeID", item.CgeID, e);
        }

        const totalRows = 1 + accessories.length;

        let tableRows = `
          <tr>
            <td style="padding: 12px 8px; border: 1px solid #e0e0e0; text-align: center; vertical-align: middle; font-weight: bold; background-color: #ffffff; color: #2c3e50;" rowspan="${totalRows}">1</td>
            <td style="padding: 12px 8px; border: 1px solid #e0e0e0; vertical-align: top; background-color: #ffffff; color: #333;"><strong>${item.CgeTypeEquipmentName || ""}</strong></td>
            <td style="padding: 12px 8px; border: 1px solid #e0e0e0; vertical-align: top; background-color: #ffffff; color: #333;">${item.CgeBrandName || ""}</td>
            <td style="padding: 12px 8px; border: 1px solid #e0e0e0; vertical-align: top; background-color: #ffffff; color: #333;">${item.CgeModelName || ""}</td>
            <td style="padding: 12px 8px; border: 1px solid #e0e0e0; vertical-align: top; background-color: #ffffff; font-family: monospace; color: #2c3e50; font-size: 13px;">${item.CgeSerie || ""}</td>
            <td style="padding: 12px 8px; border: 1px solid #e0e0e0; vertical-align: top; background-color: #ffffff; color: #666; font-size: 12px;">${equipmentObs}</td>
          </tr>`;

        for (const acc of accessories) {
          const accObs = acc.EayObservation || acc.AahObservation || "";
          tableRows += `
            <tr style="background-color: #fafbfc;">
              <td style="padding: 8px 8px 8px 15px; border: 1px solid #e0e0e0; font-size: 12px; color: #5c6a79;">
                <span style="color: #bdc3c7; margin-right: 4px;">&#8627;</span> ${acc.EayAccessoryName || ""}
              </td>
              <td style="padding: 8px 8px; border: 1px solid #e0e0e0; font-size: 12px; color: #5c6a79;">${acc.EayBrandName || ""}</td>
              <td style="padding: 8px 8px; border: 1px solid #e0e0e0; font-size: 12px; color: #5c6a79;">${acc.EayModelName || ""}</td>
              <td style="padding: 8px 8px; border: 1px solid #e0e0e0; font-size: 12px; color: #5c6a79; font-family: monospace;">${acc.EaySerie || "N/A"}</td>
              <td style="padding: 8px 8px; border: 1px solid #e0e0e0; font-size: 11px; color: #888; font-style: italic;">${accObs}</td>
            </tr>`;
        }

        const supplierText = supplierName
          ? ` (<strong>${supplierName}</strong>)`
          : "";

        const emailBody = `
          <div style="font-family: 'Segoe UI', Helvetica, Arial, sans-serif; font-size: 14px; color: #333; max-width: 900px; margin: 0 auto; border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.05);">
            <div style="background-color: #2c3e50; padding: 20px 24px; border-bottom: 3px solid #3498db;">
              <h2 style="color: #ffffff; margin: 0; font-size: 18px; letter-spacing: 0.5px;">SUNSHINE PERÚ <span style="color: #3498db; margin: 0 5px;">|</span> TI</h2>
            </div>
            <div style="padding: 30px 24px;">
              <p style="margin-top: 0; color: #2c3e50;">Estimado equipo de <strong>Almacén</strong>,</p>
              <p style="line-height: 1.6; color: #555;">
                A continuación se detalla el equipo que será devuelto al proveedor${supplierText}. Por favor, tomar conocimiento para la actualización de sus inventarios.
              </p>
              
              <table style="border-collapse: collapse; width: 100%; font-size: 13px; margin-top: 24px;">
                <thead>
                  <tr style="background-color: #f1f4f6; color: #2c3e50; text-align: left;">
                    <th style="padding: 12px 8px; border: 1px solid #e0e0e0; border-bottom: 2px solid #cbd5e1; text-align: center; width: 40px;">N°</th>
                    <th style="padding: 12px 8px; border: 1px solid #e0e0e0; border-bottom: 2px solid #cbd5e1;">TIPO</th>
                    <th style="padding: 12px 8px; border: 1px solid #e0e0e0; border-bottom: 2px solid #cbd5e1;">MARCA</th>
                    <th style="padding: 12px 8px; border: 1px solid #e0e0e0; border-bottom: 2px solid #cbd5e1;">MODELO</th>
                    <th style="padding: 12px 8px; border: 1px solid #e0e0e0; border-bottom: 2px solid #cbd5e1;">SERIE</th>
                    <th style="padding: 12px 8px; border: 1px solid #e0e0e0; border-bottom: 2px solid #cbd5e1;">OBSERVACIONES</th>
                  </tr>
                </thead>
                <tbody>
                  ${tableRows}
                </tbody>
              </table>
              
              <div style="margin-top: 30px; font-size: 12px; color: #999; border-top: 1px solid #eeeeee; padding-top: 15px; text-align: center;">
                Este es un correo automático generado por el Sistema de TI &mdash; Sunshine Perú.<br>Por favor no responder a esta dirección.
              </div>
            </div>
          </div>`;

        const payload = {
          // emailTo: "desarrollador.ti@sunshineperu.com",
          emailTo: "almacen@sunshineperu.com",
          subject: `Equipo Devuelto al Proveedor - ${item.CgeSerie || item.CgeID}`,
          bodyMail: emailBody,
          emailCC: this.returnEmailCC,
        };

        const emailResp = await GenEmailService.sendEmail(
          payload,
          this.$fun.getUserID(),
        );
        if (emailResp.status == 200) {
          await TicEquipment.updateEmailSentWarehouse(item.CgeID, this.$fun.getUserID());
          this.$refs.scrudEquipment.refresh();
          this.$fun.alert("Correo individual enviado a Almac&eacute;n", "success");
        } else {
          this.$fun.alert("Error al enviar el correo", "error");
        }
      } catch (error) {
        console.error("Error sending single return email:", error);
        this.$fun.alert("Error al enviar el correo", "error");
      }
    },"filter.CgeTypeAssigns"() {
      this.filter.AreID = null;
      this.filter.EanZone = null;
    },
    "filter.CgeTypeEquipment"(newVal) {
      const header = this.config.headers.find(
        (h) => h.value === "CgeHostname",
      );
      if (header) {
        header.text =
          newVal == this.CELLPHONE_TYPE_ID ? "IMEI" : "Hostname";
      }
    },
    "props.item"(value) {
      console.log(value);
    },
    loadEquipmentModels() {
      const self = this;
      EquipmentModelService.list("", this.$fun.getUserID()).then(function (resp) {
        if (resp.status == 200) {
          self.equipmentModels = resp.data;
        }
      });
    },
    saveNewModel() {
      const self = this;
      const name = this.newModelName.trim();
      if (!name) {
        this.$fun.alert("Ingrese un nombre de modelo", "warning");
        return;
      }
      const model = {
        EmdID: 0,
        EmdName: name,
        SecStatus: 1,
        UsrCreateID: self.$fun.getUserID(),
      };
      EquipmentModelService.save(model, self.$fun.getUserID()).then(function (saveResp) {
        if (saveResp.status == 200) {
          self.$fun.alert("Modelo agregado correctamente", "success");
          self.showAddModelInput = false;
          self.newModelName = '';
          self.loadEquipmentModels();
        }
      });
    },
  },
  mounted() {
    this.loadEquipmentModels();
  },
}
</script>

<style scoped>
::v-deep(.v-dialog--fullscreen) {
  /* backdrop-filter: blur(2px) !important; */
  background-color: rgba(0, 0, 0, 0.6) !important;
}

.truncate-single {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Header moderno */
.modern-header {
  background: linear-gradient(135deg, #606060 0%, #525c64 100%);
  padding: 12px;
  color: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions {
  display: flex;
  align-items: end;
  gap: 8px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  background: rgba(255, 255, 255, 0.2);
  padding: 8px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.header-text,
.header-title {
  flex: 1;
}

.clear-btn,
.close-btn {
  background: rgba(255, 255, 255, 0.15) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.clear-btn:hover,
.close-btn:hover {
  background: rgba(255, 255, 255, 0.25) !important;
  transform: scale(1.05);
}
</style>

<style scoped>
/* ── Status strip ── */
.rs-status {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 0.83rem;
}

.rs-status--done {
  background: linear-gradient(135deg, #2e7d32, #43a047);
  color: #fff;
}

.rs-status--pending {
  background: #fffde7;
  border: 1px solid #ffe082;
  color: #5a3e00;
}

.rs-status__icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.rs-status--pending .rs-status__icon {
  background: rgba(255, 160, 0, 0.15);
}

.rs-status__body {
  flex: 1;
  line-height: 1.3;
}

.rs-status__label {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  opacity: 0.75;
  display: block;
}

.rs-status__value {
  font-weight: 600;
  font-size: 0.88rem;
}

.rs-status__date {
  font-size: 0.75rem;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 3px 10px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.rs-status__pill {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: #7c4a00;
  background: #ffe082;
  border-radius: 20px;
  padding: 3px 10px;
}

/* ── Equipment card ── */
.rs-equip {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-left: 4px solid #e64a19;
  border-radius: 10px;
  padding: 10px 14px;
}

.rs-equip__icon {
  width: 40px;
  height: 40px;
  background: #fbe9e7;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.rs-equip__info {
  flex: 1;
  min-width: 0;
}

.rs-equip__name {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212121;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rs-equip__brand {
  font-weight: 400;
  color: #757575;
  font-size: 0.85rem;
}

.rs-equip__serie {
  font-size: 0.75rem;
  color: #9e9e9e;
  margin-top: 2px;
  display: flex;
  align-items: center;
}
</style>
